import * as reducers from '../../common/storeConstants';
import topicIntents from '../../components/topicIntentSection/TopicIntents-Reducer';
import contactOptions from '../../components/ContactOption/ContactOptionsReducer';
import callUsInfo from '../../components/callUsComponent/CallUs-Reducer';
import chatBot from '../../components/Chatbot/ChatbotReducer';
import article from '../../components/Article/ArticleReducer';

export default {
  [reducers.CONTACT_TOPIC_TREE_INTENTS]: topicIntents,
  [reducers.CONTACT_CHANNEL_OPTIONS]: contactOptions,
  [reducers.CONTACT_CALL_US]: callUsInfo,
  [reducers.CHAT_BOT]: chatBot,
  [reducers.CONTACT_ARTICLE]: article,
};
